import { Persistent, BasicKeys } from '@/utils/cache/persistent';
import { CacheTypeEnum, TOKEN_KEY } from '@/enums/cacheEnum';
import projectSetting from '@/settings/projectSetting';
import TokenManager from '@yakies/token';

const { permissionCacheType } = projectSetting;
const isLocal = permissionCacheType === CacheTypeEnum.LOCAL;
const tm = new TokenManager();

export function getToken() {
  return tm.getToken() || '';
  // return getAuthCache(TOKEN_KEY);
}

export function getAuthCache<T>(key: BasicKeys) {
  const fn = isLocal ? Persistent.getLocal : Persistent.getSession;
  return fn(key) as T;
}

export function setAuthCache(key: BasicKeys, value) {
  const fn = isLocal ? Persistent.setLocal : Persistent.setSession;
  return fn(key, value, true);
}

export function clearAuthCache(immediate = true) {
  const fn = isLocal ? Persistent.clearLocal : Persistent.clearSession;
  return fn(immediate);
}

export function setMenuListCache(key: BasicKeys, value) {
  const fn = isLocal ? Persistent.setLocal : Persistent.setSession;
  return fn(key, value, true);
}

export function getMenuListCache(key: BasicKeys) {
  const fn = isLocal ? Persistent.getLocal : Persistent.getSession;
  return fn(key);
}

export const checkPageId = (routes) => {
  const userStore = useUserStore();
  const perms = userStore.perms;

  return userStore.getUserInfo.isAdmin
    ? routes
    : routes
        .filter((route) => {
          const { id } = route.meta;
          if (!id) return true;
          if (id === '__micro__degradation__') return true;
          return perms.includes(id);
        })
        .map((routeItem) => {
          const subRoute = { ...routeItem };
          if (subRoute.children) {
            subRoute.children = checkPageId(subRoute.children);
          }
          return subRoute;
        });
};
